module.exports = "/static-assets/_next/static/images/sweater-2-b53cc03ae8b3c752b0f57debf15b7213.png";